import { PAY_CYCLE_FAILED, PAY_CYCLE_LOADING, PAY_CYCLE_SUCCESS } from "./constants";
import { payCycle, payCycleFailed, payCycleLoading } from "./helper";

const INITIAL_STATE = {
  loading: false,
  currentMonth: 0,
  currentYear: 0,
  numOfSentMessages: 0,
  receivedMessages: [],
  sentMessages: [],
  openConversations: [],
  fetchError: "",
};

const payCycleReducer = (state = INITIAL_STATE, actions) => {
  switch (actions.type) {
    case PAY_CYCLE_LOADING:
      return payCycleLoading(state, actions);
    case PAY_CYCLE_SUCCESS:
      return payCycle(state, actions);

    case PAY_CYCLE_FAILED:
      return payCycleFailed(state, actions);

    default:
      return state;
  }
};

export default payCycleReducer;
